<template>
  <v-layout align-start>
    <v-flex>
      <v-data-table
        :headers="headers"
        :items="tipooperaciones"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar color="white">
            <v-toolbar-title><v-icon>add_business</v-icon></v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field
              class="text-xs-center"
              v-model="search"
              append-icon="search"
              label="Búsqueda"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on" fab small>
                <span class="material-icons"> add </span>
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          v-model="combustiblenombre"
                          label="Nombre del Combustible "
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          v-model="combustiblecosto"
                          label="Costo del Combustible "
                          type="number"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" v-show="valida">
                        <v-row
                          class="red--text"
                          v-for="v in validamensaje"
                          :key="v"
                          v-text="v"
                        ></v-row>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="blue darken-1" text @click="close"
                    >Cancelar</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="guardar"
                    >Guardar</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="adModal" max-width="700">
              <v-card>
                <v-card-title class="headline" v-if="adAccion == 1"
                  >¿Deseas Activar El Combustible?</v-card-title
                >
                <v-card-title class="headline" v-if="adAccion == 2"
                  >¿Deseas Suspender El Combustible?</v-card-title
                >
                <v-card-text>
                  Estás a punto de
                  <span v-if="adAccion == 1">Activar</span>
                  <span v-if="adAccion == 2">Desactivar</span>
                  el Combustible {{ adNombre }}
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="green darken-1" @click="activarDesactivarCerrar"
                    >Cancelar</v-btn
                  >
                  <v-btn
                    v-if="adAccion == 1"
                    color="orange darken-4"
                    @click="activar"
                    >Activar</v-btn
                  >
                  <v-btn
                    v-if="adAccion == 2"
                    color="orange darken-4"
                    @click="desactivar"
                    >Suspender</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>

            
          </v-toolbar>
        </template>
        <template v-slot:item.action="{ item }">
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-icon dense class="mr-2" @click="editItem(item)" v-on="on"
                >edit</v-icon
              >
            </template>
            <span>Editar Combustible</span>
          </v-tooltip>
          <template v-if="item.combustibleestatus == 1">
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-icon
                  dense
                  class="mr-2"
                  @click="ActivarDesactivarMostrar(2, item)"
                  v-on="on"
                  >block</v-icon
                >
              </template>
              <span>Desactivar Combustible</span>
            </v-tooltip>
          </template>
          <template v-else>
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-icon
                  dense
                  class="mr-2"
                  @click="ActivarDesactivarMostrar(1, item)"
                  v-on="on"
                  >check</v-icon
                >
              </template>
              <span>Activar Combustible</span>
            </v-tooltip>
          </template>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="listar">Reset</v-btn>
        </template>

        <template v-slot:item.combustibleestatus="{ item }">
          <v-chip
            :color="getColor(item.combustibleestatus)"
            dark
            v-if="item.combustibleestatus == 1"
            >ACTIVO</v-chip
          >
          <v-chip
            :color="getColor(item.combustibleestatus)"
            dark
            v-if="item.combustibleestatus == 2"
            >SUSPENDIDO</v-chip
          >
        </template>

        <template v-slot:item.combustiblefecha="{ item }">
          <p>{{ getHumanDate(item.combustiblefecha) }}</p>
        </template>
      </v-data-table>




      



    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      // Variable categoria
      tipooperaciones: [],
      dialog: false,
      headers: [
        { text: "Accion", value: "action", sortable: false },
        { text: "Nombre", value: "combustiblenombre" },
        { text: "Costo", value: "combustiblecosto" },
        { text: "Estatus", value: "combustibleestatus", sortable: false },
      ],

      search: "",
      editedIndex: -1,
      //Declaracion de varaibles
      combustiblenombre: "",
      combustiblecosto: "",
      combustibleid: "",

      // Declara variables de Validacion
      valida: 0,
      validamensaje: [],
      // Declara Varaiables para activar o desactivar categorias
      adModal: 0,
      adAccion: 0,
      adNombre: "",
      adId: "",
    };
  },
  // Crea una nueva categoria si es -1
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Nuevo Combustible"
        : "Actualizando Combustible";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.listar();
  },

  //
  methods: {
    getHumanDate: function (date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },

    // metodo listar
    listar() {
      // Variable para cargar los datos del api
      let me = this;
      let header = { Authorization:this.$store.state.token };
      let configuracion = { headers: header };
      // Manda llamar al listado e catalogos
      axios
        .get("api/combustibles/listarcombustibles", configuracion)
        .then(function (response) {
          //console.log(response.data.vehiculo);
          me.tipooperaciones = response.data.combustible;
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    // Color
    getColor(socioestatus) {
      if (socioestatus == 1) return "#3F8103";
      if (socioestatus == 2) return "red";
    },

    // Actualiza la categotia
    editItem(item) {
      this.combustibleid = item.combustibleid;
      this.combustiblenombre = item.combustiblenombre;
      this.combustiblecosto = item.combustiblecosto;
      this.editedIndex = 1;
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.limpiar();
    },

    limpiar() {
      this.validamensaje="";
      this.combustibleid = "";
      this.combustiblenombre = "";
      this.combustiblecosto = "";
      this.editedIndex = -1;
    },

    guardar() {
      if (this.validar()) {
        return;
      }

      var qs = require("qs");
      var data = qs.stringify({
        json:
          '{"combustiblenombre":"' +
          this.combustiblenombre +
          '","combustiblecosto":"' +
          this.combustiblecosto +
          '","usuarioid":"' +
          this.$store.state.usuario.usuarioid +
          '"}',
      });

      let header = { Authorization:this.$store.state.token };
      let configuracion = { headers: header };
      if (this.editedIndex > -1) {
        //Editar
        let me = this;
        axios
          .put(
            "api/combustibles/actualizarcombustibles/" + me.combustibleid,
            data,
            configuracion
          )
          .then(function (response) {
            me.close();
            me.listar();
            me.limpiar();
            me.$swal("Combustible Actualizado con Exito");
          })
          .catch(function (error) {
            console.log(error);
            if (error.response.data.code == 400) {
              me.$swal("La Sesión a Expirado");
              me.$store.dispatch("salir");
            }
          });
      } else {
        //Guardar
        let me = this;
        axios
          .post("api/combustibles/crearcombustibles", data, configuracion)
          .then(function (response) {
            me.close();
            me.listar();
            me.limpiar();
            me.$swal("Combustible Guardado con Exito");
          })
          .catch(function (error) {
            console.log(error);
            if (error.response.data.code == 400) {
              me.$swal("La Sesión a Expirado");
              me.$store.dispatch("salir");
            }
          });
      }
    },

    validar() {
      this.valida = 0;
      this.validamensaje = [];

      if (!this.combustiblenombre) {
        this.validamensaje.push("Nombre Vacio");
      }
      if (!this.combustiblecosto) {
        this.validamensaje.push("Costo Vacio");
      }

      if (this.validamensaje.length) {
        this.valida = 1;
      }
      return this.valida;
    },

    ActivarDesactivarMostrar(accion, item) {
      this.adModal = 1;
      this.adNombre = item.combustiblenombre;
      this.combustibleid = item.combustibleid;
      if (accion == 1) {
        this.adAccion = 1;
      } else if (accion == 2) {
        this.adAccion = 2;
      } else {
        this.adModal = 0;
      }
    },
    activarDesactivarCerrar() {
      this.adModal = 0;
    },
    activar() {
      var qs = require("qs");
      var data = qs.stringify({
        json: '{"combustibleestatus":"1"}',
      });

      let me = this;
      let header = { Authorization:this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put(
          "api/combustibles/activarcombustibles/" + this.combustibleid,
          data,
          configuracion
        )
        .then(function (response) {
          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },
    desactivar() {
      var qs = require("qs");
      var data = qs.stringify({
        json: '{"combustibleestatus":"2"}',
      });
      let me = this;
      let header = { Authorization:this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put(
          "api/combustibles/activarcombustibles/" + this.combustibleid,
          data,
          configuracion
        )
        .then(function (response) {
          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },
  },
};
</script>